@if (!requestAlreadySentToday) {
  <mat-card appearance="outlined" class="request-transfer" data-test-id="request-transfer-container">
    <h5 class="font-bold">It is all about perfect match!</h5>
    <p>Are you thinking about something new? Let us know.</p>
    <button
      [loading]="requestPending"
      (click)="requestTransfer()"
      class="request-transfer-button"
      color="primary"
      data-test-id="request-transfer-container-button"
      mat-flat-button
    >
      I want to change my project.
    </button>
  </mat-card>
}

@if (requestAlreadySentToday) {
  <mat-card appearance="outlined" class="request-transfer-sent" data-test-id="request-transfer-sent-container">
    <h5 class="font-bold">Thank you for your feedback.</h5>
    <p>Please expect a call from your agent!</p>
  </mat-card>
}
